<template>
  <img :data-src="preview" class="uk-flex-center" uk-img>
</template>

<script>
  export default {
    name: 'image-renderer',
    props: {
      preview: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped>
img {
  height: 100%;
}
</style>
